import { createSelector } from '@reduxjs/toolkit';
import { selectFeesState } from '../../store/selectors';

export const selectAfsls = createSelector(selectFeesState, (fees) => fees.afsls);

export const selectAfslId = createSelector(selectFeesState, (fees) => fees.afslId);

export const selectTemplates = createSelector(selectFeesState, (fees) => fees.templates);
